import React from "react";
import { Newspaper } from "@phosphor-icons/react";

export default function RegionalNewsSummary({ region, data, loading }) {
  const s = data?.summary;
  return (
    <div className="bg-surface border border-white/10 p-5" data-testid="regional-news-summary">
      <div className="flex items-center gap-2 mb-3">
        <Newspaper size={18} weight="duotone" color="#FFCC00" />
        <h3 className="heading text-lg font-semibold">News Brief · {region}</h3>
        <span className="overline ml-auto">claude · sonnet 4.5</span>
      </div>
      {loading ? (
        <div className="space-y-2">
          <div className="h-3 bg-white/5 w-full" />
          <div className="h-3 bg-white/5 w-11/12" />
          <div className="h-3 bg-white/5 w-9/12" />
        </div>
      ) : (
        <>
          <p className="text-sm leading-relaxed text-white/85" data-testid="regional-news-narrative">
            {data?.narrative || "Awaiting regional news..."}
          </p>
          {s && (
            <div className="flex items-center gap-3 mt-3 pt-3 border-t border-white/10">
              <span className="mono text-xs text-bullish">{s.positive || 0}↑</span>
              <span className="mono text-xs text-white/60">{s.neutral || 0}=</span>
              <span className="mono text-xs text-bearish">{s.negative || 0}↓</span>
              <span className="overline ml-auto">{data?.headline_count || 0} headlines</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
